import React from 'react';

import './TooTip.scss';

const ToolTip = ({ children, tooltipLabel, className = '' }) => (
  <div className={'tooltip ' + className}>
    {children}
    <span className="tooltip-label">{tooltipLabel}</span>
  </div>
);

export default ToolTip;
